import { data as routerData } from 'react-router';
import type { LoaderFunctionArgs } from '~/types/route-args';
import ContactPage, {
    handle as contactHandle,
} from '@modules/professional/page/ContactPage';
import { loader as contactLoader } from '@modules/professional/page/loaders/contact-page-loader.server';
import { isProfessionalRevampActive } from '@modules/professional/util/is-professional-revamp-active.server';
import { getSession } from '~/modules/root/util/session.server';
import { ProfessionalContactPageRevamp } from '~/ui-rocco/pages/professional-detail/ProfessionalContactPageRevamp';
import { shouldRevalidateLeaf } from '~/modules/root/util/should-revalidate-leaf';
import type { APHandle } from '~/modules/root';
import { useShowProfessionalRevamp } from '@modules/professional/hook/use-professional-layout-data';

/**
 * When the revamp is active the Contact tab becomes a full editorial page: the
 * reused hero/closing need the overview data, while the dark location section
 * needs the contact data (map key + linked-profile locations), so the loader
 * merges both. Otherwise it serves the legacy map + location-list contact page.
 */
export const loader = async (args: LoaderFunctionArgs) => {
    if (!isProfessionalRevampActive(args.context, args.request)) {
        return contactLoader(args);
    }

    // The revamp's shared overview payload comes from the persistent layout
    // loader; this route only fetches the contact tab's own data.
    const { frontendEnv, linkedProfiles } = await contactLoader(args);
    const session = await getSession(args.request);

    return routerData(
        { frontendEnv, linkedProfiles },
        { headers: await session.getHeaders() },
    );
};

export const handle: APHandle = {
    ...contactHandle,
    professionalRevampLayout: true,
};

const ProfessionalContactRoute = () => {
    const showRevamp = useShowProfessionalRevamp();

    return showRevamp ? <ProfessionalContactPageRevamp /> : <ContactPage />;
};

export const shouldRevalidate = shouldRevalidateLeaf;
export default ProfessionalContactRoute;
